/**
 * set default config here
 */

const companyRegistration = {
  showExistingCompanies: false,
};

export { companyRegistration };
